export function clone<T>(i: T): T {
    return JSON.parse(JSON.stringify(i)) as T;
}
